
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"#55A3FF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.667 8A6.667 6.667 0 101.333 8a6.667 6.667 0 0013.334 0zm-1 0A5.667 5.667 0 112.332 8a5.667 5.667 0 0111.335 0zM9.363 5.984a.5.5 0 00-.754-.652L6.285 7.646l-.049.056a.5.5 0 00.049.652l2.324 2.314.056.049a.5.5 0 00.65-.05l.05-.056a.5.5 0 00-.05-.651L7.346 8l1.967-1.96.049-.056z","fill":"inherit"}})])
          )
        }
      }
    